import React from "react";
import IntegrationReactSelect from "../Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import {BehaviorSubject, Observable, Subscription, throwError} from "rxjs";
import {catchError, debounceTime, distinctUntilChanged, filter, map, pluck, startWith, switchMap} from "rxjs/operators";
import axios from 'axios';
import {observable} from "mobx";
import {inject, observer} from "mobx-react";
import i18n from "i18next";

export interface State {
    suggestions: [] | undefined;
    query: string | null;
}

const state: State = {
    suggestions: undefined,
    query: null,
};

export class RxStore {

    private subject = new BehaviorSubject<State>(state);
    private store = this.subject.asObservable().pipe(distinctUntilChanged());

    get value() {
        return this.subject.value;
    }

    select<T>(name: string): Observable<T> {
        return this.store.pipe(pluck(name));
    }

    set(name: string, state: any) {
        this.subject.next({
            ...this.value, [name]: state
        });
    }

}

const store = new RxStore();

@inject("uiStore")
@observer
class PostEditor extends React.Component<any, any> {

    @observable suggestions: any[] = [];

    @observable loading: boolean = false;

    data: any = null;

    querySubscribe: Subscription | undefined;

    BASE_URL = process.env.NODE_ENV === 'production' ? window.location.protocol + "//" + window.location.host + "/" : 'http://giladt:9090/';

    query$: Observable<string> = store.select('query');

    onInputChange = (query: string) => {
        if (query.length > 0) {
            store.set('query', query);
        }
    };

    componentWillUnmount(): void {
        if (this.querySubscribe) {
            this.querySubscribe.unsubscribe();
            store.set('query', null);
        }
    }

    componentDidMount(): void {
        this.subscribeToQuery();
    }

    subscribeToQuery() {
        this.querySubscribe = this.query$.pipe(
            startWith(null),
            debounceTime(750),
            distinctUntilChanged(),
            filter((query) => typeof query === 'string'),
            switchMap(query => {
                this.loading = true;
                return axios.post(`${this.BASE_URL}wp-admin/admin-ajax.php`, `action=wpex_search_post_by_title&query=${query}`, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
            }),
            map((response) => {
                this.suggestions = response.data.posts.map((post: any) => ({
                    ...post,
                    'label': post.post_title,
                    'value': post.post_title,
                    'image_src': post.image_src,
                }));
                this.loading = false;
            }),
            catchError((err, caught) => throwError(err))
        ).subscribe();
    }

    changeSelection = (selected: any) => {
        if (selected === null || (selected && selected.ID)) {
            if (selected) {
                delete selected.post_content;
            }
            this.props.onUpdateData('post', selected);
        }
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div dir={this.props.uiStore.dir}>
                <IntegrationReactSelect
                    placeholder={i18n.t('Select post')}
                    value={this.props.widget.data.post}
                    suggestions={this.suggestions}
                    inputChange={this.onInputChange}
                    onChange={this.changeSelection}
                    loading={this.loading}
                />

                <div className='fields-wrapper'>
                    <FormControl>
                        <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            value={this.props.widget.data.size}
                            onChange={(event: any) => this.props.onUpdateData('size', event.target.value)}
                        >
                            <FormControlLabel value="Small" control={<Radio/>} label={i18n.t("Small")}/>
                            <FormControlLabel value="Large" control={<Radio/>} label={i18n.t("Large")}/>
                        </RadioGroup>
                    </FormControl>
                    <div>
                        <FormControl>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={this.props.widget.data.isBgGray}
                                    onChange={(event: any) => this.props.onUpdateData('isBgGray', event.target.checked)}
                                    value="#dadada"/>}
                                label={i18n.t("Gray background")}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        );
    }
}

export default PostEditor;

